import {getAppLang, getProperty, getUserToken} from "../../../../utils";
import axios from "axios";
import {
    BOOKING_IMPORT,
    BOOKING_IMPORT_CHECK,
    BOOKING_IMPORT_SEARCH,
    BOOKING_IMPORT_SAVE,
    BOOKING_IMPORT_FACILITIES_SEARCH,
    BOOKING_IMPORT_FACILITIES_SAVE,
} from "../../../../constants/api.constants";
import {bookingImportConstants} from "../../../../constants/General/bookingImport.constants";

export function bookingImportSetup(params) {

    const requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        },
        body: {
            params: {
                property_id: getProperty(),
                booking_hotel_id: params.booking_hotel_id,
                sync: true
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'BOOKING_IMPORT_SETUP',
            payload: axios.post(BOOKING_IMPORT, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

export function bookingImportStatus(setupId) {

    const requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        },
    };

    const url = `${BOOKING_IMPORT}/status?setup_id=${setupId}&property_id=${getProperty()}`;

    return dispatch => {
        dispatch({
            type: 'BOOKING_IMPORT_STATUS',
            payload: axios.get(url, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

export function bookingImportCheck() {

    const requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        },
    };

    const url = `${BOOKING_IMPORT_CHECK}?property_id=${getProperty()}`;

    return dispatch => {
        dispatch({
            type: 'BOOKING_IMPORT_CHECK',
            payload: axios.get(url, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

export function bookingPhotoSearch(params) {

    const requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        },
    };

    const url = `${BOOKING_IMPORT_SEARCH}?hotel_id=${params.hotel_id}&property_id=${getProperty()}`;

    return dispatch => {
        dispatch({
            type: 'BOOKING_PHOTO_SEARCH',
            payload: axios.get(url, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

export function bookingPhotoSave(params) {

    const requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        },
        body: {
            params: {
                property_id: getProperty(),
                booking_hotel_id: params.booking_hotel_id,
                selected_photos: params.selected_photos,
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'BOOKING_PHOTO_SAVE',
            payload: axios.post(BOOKING_IMPORT_SAVE, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

export function clearBookingImport() {
    return dispatch => {
        dispatch({
            type: bookingImportConstants.BOOKING_IMPORT_CLEAR,
        })
    }
}

export function clearBookingPhoto() {
    return dispatch => {
        dispatch({
            type: bookingImportConstants.BOOKING_PHOTO_CLEAR,
        })
    }
}

export function bookingFacilitySearch(params) {

    const requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        },
    };

    const url = `${BOOKING_IMPORT_FACILITIES_SEARCH}?hotel_id=${params.hotel_id}&property_id=${getProperty()}`;

    return dispatch => {
        dispatch({
            type: 'BOOKING_FACILITY_SEARCH',
            payload: axios.get(url, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

export function bookingFacilitySave(params) {

    const requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        },
        body: {
            params: {
                property_id: getProperty(),
                fact_ids: params.fact_ids,
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'BOOKING_FACILITY_SAVE',
            payload: axios.post(BOOKING_IMPORT_FACILITIES_SAVE, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

export function clearBookingFacility() {
    return dispatch => {
        dispatch({
            type: bookingImportConstants.BOOKING_FACILITY_CLEAR,
        })
    }
}
